import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { LoadingComponent } from "../../../components/common/loading/loading.component";
import { MetricCardViewComponent } from "../../../components/metric-card-view/metric-card-view.component";
import { BaseLayoutComponent } from "../../base-layout.component";

/**
 * @class SmartTestReviewReportComponent
 * @extends BaseLayoutComponent
 * @description This component is responsible for rendering the smart test review report, including metrics, charts, and other summarized data.
 */
@Component({
  selector: "app-smart-test-review-report",
  standalone: true,
  imports: [MetricCardViewComponent, CommonModule, LoadingComponent],
  templateUrl: "./smart-test-review-report.component.html",
  styleUrl: "./smart-test-review-report.component.scss",
})
export class SmartTestReviewReportComponent extends BaseLayoutComponent {
  data: any = {};
  isLoading = true;

  customClasses = {
    metricHeader: "no-bg border-0",
    card: "p-4 shadow",
  };

  /**
   * @method ngOnInit
   * @description Angular lifecycle hook that initializes the component and starts loading the data.
   */
  ngOnInit() {
    this.loadData();
  }

  /**
   * @method loadData
   * @description Simulates the loading of data by setting a timeout. Populates the `data` property with metrics and chart configurations after the loading period.
   */
  loadData() {
    setTimeout(() => {
      this.isLoading = false;
      this.data = {
        groups: [
          {
            groupDisplayName: "",
            metrics: [
              {
                metricDisplayName: "",
                mericName: "summary",
                metricType: "key_value_card",
                order: 1,
                size: "col-md-12",
                data: [
                  {
                    display_name: "Number of Test Cases",
                    value: "16",
                    order: 1,
                  },
                  {
                    display_name: "Error-Handling Test Coverage %",
                    value: "37.5",
                    order: 2,
                  },
                  {
                    display_name: "Positive Test Coverage %",
                    value: "76.06%",
                    order: 3,
                  },
                  {
                    display_name: "Negative Test Coverage",
                    value: "44%",
                    order: 4,
                  },
                  {
                    display_name: "Test Coverage w.r.t Requirement Document%",
                    value: "36.36%",
                    order: 5,
                  },
                  {
                    display_name:
                      "Boundary Value Analysis Test Case Coverage %",
                    value: "100%",
                    order: 6,
                  },
                ],
              },
            ],
          },
          {
            groupDisplayName: "",
            metrics: [
              {
                metricDisplayName: "Positive Test Coverage",
                mericName: "positiveTestCoverage",
                metricType: "bar_chart",
                order: 2,
                size: "col-md-6",
                data: {
                  labels: ["Q1", "Q2", "Q3", "Q4"],
                  datasets: [
                    {
                      label: "Sales",
                      data: [540, 325, 702, 620],
                      backgroundColor: [
                        "rgba(249, 115, 22, 0.2)",
                        "rgba(6, 182, 212, 0.2)",
                        "rgb(107, 114, 128, 0.2)",
                        "rgba(139, 92, 246, 0.2)",
                      ],
                      borderColor: [
                        "rgb(249, 115, 22)",
                        "rgb(6, 182, 212)",
                        "rgb(107, 114, 128)",
                        "rgb(139, 92, 246)",
                      ],
                      borderWidth: 1,
                    },
                  ],
                },
              },
              {
                metricDisplayName: "Negative Test Coverage",
                mericName: "negativeTestCoverage",
                metricType: "bar_chart",
                order: 3,
                size: "col-md-6",
                data: {
                  labels: ["Q1", "Q2", "Q3", "Q4"],
                  datasets: [
                    {
                      label: "Sales",
                      data: [540, 325, 702, 620],
                      backgroundColor: [
                        "rgba(249, 115, 22, 0.2)",
                        "rgba(6, 182, 212, 0.2)",
                        "rgb(107, 114, 128, 0.2)",
                        "rgba(139, 92, 246, 0.2)",
                      ],
                      borderColor: [
                        "rgb(249, 115, 22)",
                        "rgb(6, 182, 212)",
                        "rgb(107, 114, 128)",
                        "rgb(139, 92, 246)",
                      ],
                      borderWidth: 1,
                    },
                  ],
                },
              },
            ],
          },
          {
            groupDisplayName: "",
            metrics: [
              {
                metricDisplayName: "Missing Test Case Trends",
                mericName: "summary",
                metricType: "line_chart",
                order: 1,
                size: "col-md-6",
                data: {
                  "2024-07-26": {
                    historical_data: 5,
                  },
                  "2024-07-28": {
                    historical_data: 12,
                  },
                  "2024-07-29": {
                    historical_data: 10,
                  },
                },
              },
              {
                metricDisplayName: "Test Coverage Distribution",
                mericName: "summary",
                metricType: "donut_chart",
                order: 1,
                size: "col-md-6",
                data: {
                  fail_count: 22,
                  pass_count: 22,
                },
              },
            ],
          },
        ],
      };
    }, 3000);
  }

  // Method to get Bootstrap class based on the size attribute in JSON config
  getTileClass(size: string): string {
    return size || "col-md-12"; // Default to full width if no size is provided
  }
}
